import { runtimeGraphIds } from '@/models/logic/RuntimeGraphIds';
import type Context from '@/context';
import type { GlobalTilePosition } from '@/types';
import { Point } from '@/models/Point';
import { ChipInstanceModel } from '@/models/ChipInstanceModel';
import type { IChipInstanceModel, ILogicGraph, IPoint } from '@/interfaces/models';
import type { ChipId } from '@/types/ids';
import { LogicGraphFactory } from '@/factories/LogicGraphFactory';

export class ChipInstanceModelFactory {
  constructor(private readonly logicGraphFactory: LogicGraphFactory) {}

  create(
    context: Context,
    chipId: ChipId,
    originPoint: IPoint,
    logicGraph: ILogicGraph,
    originGlobalTileLocation?: GlobalTilePosition,
  ): IChipInstanceModel {
    return new ChipInstanceModel(
      context,
      chipId,
      originPoint instanceof Point ? originPoint : Point.fromData(originPoint.data),
      logicGraph,
      originGlobalTileLocation,
    );
  }

  createEditingInstance(context: Context, chipId: ChipId): IChipInstanceModel {
    const logicGraph = this.logicGraphFactory.create(runtimeGraphIds(context));
    return new ChipInstanceModel(context, chipId, new Point(0, 0), logicGraph);
  }
}
